import { makeStyles } from '@material-ui/core';
var styles = makeStyles({
    root: {
        color: 'var(--blanco)',
        display: 'flex',
        height: 22,
        alignItems: 'center',
    },
    active: {
        color: 'var(--primario-morado)',
    },
    circle: {
        width: 22,
        height: 22,
        borderRadius: '50%',
        border: '2px solid var(--primario-morado)',
        backgroundColor: 'currentColor',
    },
    completed: {
        color: 'var(--primario-morado)',
        zIndex: 1,
        fontSize: 18,
    },
});
export default styles;
